import Breadcrumb from '@/components/common/Breadcrumb';

const EmailMagazineMain = () => {
  return (
    <div>
      <Breadcrumb />
      <div className="card">
        <h1 className="text-2xl font-bold text-admin-text mb-4">メールマガ用データDL</h1>
        <p className="text-admin-textLight mb-6">
          メールマガジン用のデータをダウンロードします。
        </p>
        <div className="bg-blue-50 border border-blue-200 text-blue-800 px-4 py-3 rounded">
          <p className="text-sm">
            この機能は今後のPBIで実装予定です。
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailMagazineMain;
